<img
  [src]="iconPath"
  alt="Icon {{icon}}"
  [ngStyle]="{'width.px': size, 'height.px': size}"
/>
